// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"279":"QueuePage","773":"QueuesPage","789":"LoginPage","845":"Page404","846":"RegisterPage"}[chunkId] + "." + {"279":"75bf23a7","773":"f1c25152","789":"5887bc70","845":"e06198e0","846":"7418dc09"}[chunkId] + ".chunk.css";
};